frontApp.reviewsPhotosSlider = {
  init() {
    const $slider = $('.js-reviews-photos-slider');
    if (!$slider.length) {
      return;
    }

    function lazyLoadSlideImage(sliderInstance) {
      const $visible = $(sliderInstance.visibleSlides);
      const $img = $visible.add($visible.prev()).add($visible.next()).find('.js-lazy-load').not('.loaded');
      if ($img.filter('.loaded').length !== $img.length && frontApp.lazyLoadGlobalInstance) {
        $.each($img, (idx, img) => {
          LazyLoad.load(img);
        });
      }
    }

    $.each($slider, function () {
      const $curSlider = $(this);
      const $nextEl = $curSlider.find('.js-reviews-photos-slider__nav--next');
      const $prevEl = $curSlider.find('.js-reviews-photos-slider__nav--prev');

      const sliderInstance = new Swiper($curSlider.find('.swiper')[0], {
        init: false,
        // loop: true, // Не работает корректно с lazy-load
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 8,
        slidesOffsetBefore: 16,
        watchSlidesProgress: true, // Нужно, чтобы получать visibleSlides из экземпляра
        noSwipingSelector: '.button, .button-favorite',
        watchOverflow: true,

        navigation: {
          nextEl: $nextEl[0],
          prevEl: $prevEl[0],
        },

        breakpoints: {
          992: {
            spaceBetween: 18,
            slidesOffsetBefore: 0,
          },
        },

        on: {
          transitionEnd() {
            lazyLoadSlideImage(sliderInstance);
          },
        },
      });

      sliderInstance.on('init', () => {
        $curSlider.addClass('is-loaded');
        lazyLoadSlideImage(sliderInstance);
      });

      Fancybox.bind('.js-reviews-photos-slider-zoom', {
        mainClass: 'image-zoom-theme',
        infinite: false,
        Toolbar: {
          display: [
            'zoom',
            'close',
          ],
        },
        on: {
          shouldClose: (fancybox) => {
            const { page } = fancybox.Carousel;
            if (sliderInstance.params.loop) {
              sliderInstance.slideToLoop(page, 0);
            } else {
              sliderInstance.slideTo(page, 0);
            }
          },
        },
      });

      sliderInstance.init();
    });
  },
};
